var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pbz-font d-flex flex-column justify-content-center"},[_c('div',{staticClass:"d-flex"},[_c('h3',[_vm._v(_vm._s(_vm.$t('invoice.list_invoice')))])]),_c('div',{staticClass:"d-flex flex-column justify-content-center",class:_vm.$style.paymentContainer},[_c('div',{class:_vm.$style.paymentContent},[_c('ListInvoice')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }